import { render, staticRenderFns } from "./user-manage.vue?vue&type=template&id=494a2c4e&scoped=true&"
import script from "./user-manage.vue?vue&type=script&lang=js&"
export * from "./user-manage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494a2c4e",
  null
  
)

export default component.exports